import { Link } from 'react-router-dom';
import LegalLayout from '../components/legal/LegalLayout.jsx';

const TOC = [
  { id: 'objeto', label: '1. Objeto' },
  { id: 'identificacion', label: '2. Identificación' },
  { id: 'aceptacion', label: '3. Aceptación' },
  { id: 'acceso', label: '4. Acceso a los servicios' },
  { id: 'programa', label: '5. El programa Random College' },
  { id: 'pago', label: '6. Pago y suscripción' },
  { id: 'cancelacion', label: '7. Cancelación y devoluciones' },
  { id: 'propiedad', label: '8. Propiedad intelectual' },
  { id: 'uso', label: '9. Uso permitido' },
  { id: 'exclusion', label: '10. Exclusión de responsabilidad' },
  { id: 'enlaces', label: '11. Enlaces externos' },
  { id: 'modificaciones', label: '12. Modificaciones' },
  { id: 'nulidad', label: '13. Nulidad parcial' },
  { id: 'legislacion', label: '14. Legislación y jurisdicción' },
  { id: 'contacto', label: '15. Contacto' },
];

export default function TerminosPage() {
  return (
    <LegalLayout
      title="Términos y Condiciones"
      intro="Las reglas que rigen el uso de esta web y la relación entre Random College y tú como usuario. Léelas: te ahorrarán problemas a futuro."
      meta={[
        { label: 'Última actualización', value: '29 de abril de 2026' },
        { label: 'Versión', value: '1.0' },
        { label: 'Vigencia', value: 'Inmediata' },
      ]}
      toc={TOC}
    >
      <div className="legal-callout">
        <strong>Resumen rápido:</strong> Random College es un programa formativo online por
        suscripción mensual gestionado a través de la plataforma Skool. Puedes cancelar cuando
        quieras desde tu cuenta. El contenido es nuestro y no puedes redistribuirlo. La compra
        implica aceptar estos términos.
      </div>

      <h2 id="objeto">1. Objeto</h2>
      <p>
        Los presentes Términos y Condiciones (en adelante, los “Términos”) regulan el acceso,
        navegación y uso del sitio web <strong>randomcollege.com</strong> (en adelante, el “Sitio”)
        y la contratación del programa formativo <strong>Random College</strong> (en adelante, el
        “Programa”) por parte de los usuarios.
      </p>

      <h2 id="identificacion">2. Identificación</h2>
      <p>El Sitio y el Programa son operados por:</p>
      <ul>
        <li>
          <strong>Titular:</strong> [Razón social pendiente de completar]
        </li>
        <li>
          <strong>NIF/CIF:</strong> [Pendiente]
        </li>
        <li>
          <strong>Domicilio social:</strong> [Pendiente, Madrid, España]
        </li>
        <li>
          <strong>Email de contacto:</strong>{' '}
          <a href="mailto:hola@randomcollege.com">hola@randomcollege.com</a>
        </li>
        <li>
          <strong>Inscripción Registro Mercantil:</strong> [Datos registrales pendientes]
        </li>
      </ul>

      <h2 id="aceptacion">3. Aceptación</h2>
      <p>
        El uso del Sitio y la contratación del Programa implican la aceptación expresa y sin
        reservas de estos Términos en su totalidad, así como de la{' '}
        <Link to="/privacidad">Política de Privacidad</Link>. Si no estás de acuerdo con alguna de
        estas condiciones, debes abstenerte de usar el Sitio o contratar el Programa.
      </p>
      <p>
        La aceptación de estos Términos requiere ser mayor de edad y tener capacidad legal
        suficiente para contratar.
      </p>

      <h2 id="acceso">4. Acceso a los servicios</h2>
      <p>
        El acceso al Sitio es libre y gratuito. Algunos contenidos o servicios del Sitio pueden
        requerir registro previo. La contratación del Programa requiere darse de alta en la
        plataforma <strong>Skool</strong> y abonar la suscripción correspondiente.
      </p>
      <p>
        Random College se reserva el derecho a denegar o retirar el acceso al Sitio o al Programa,
        sin necesidad de previo aviso, a usuarios que incumplan estos Términos o realicen un uso
        indebido de los servicios.
      </p>

      <h2 id="programa">5. El programa Random College</h2>
      <p>
        Random College es un programa formativo online en formato comunidad, alojado en la
        plataforma <strong>Skool</strong> (
        <a href="https://www.skool.com" target="_blank" rel="noopener noreferrer">
          skool.com
        </a>
        ). Incluye, entre otros recursos:
      </p>
      <ul>
        <li>Acceso a módulos de formación en marketing digital, emprendimiento, ventas, podcasting y otras áreas.</li>
        <li>Comunidad privada con otros alumnos y profesores.</li>
        <li>Sesiones en directo y contenidos actualizados periódicamente.</li>
        <li>Acceso desde navegador y app móvil de Skool.</li>
      </ul>
      <p>
        El alcance, duración y formato concretos de los contenidos pueden variar a lo largo del
        tiempo. Random College se reserva el derecho a actualizar, ampliar o modificar el Programa
        sin previo aviso, manteniendo en todo caso la calidad y propósito formativo del mismo.
      </p>
      <h3>5.1. Naturaleza de la formación</h3>
      <p>
        Random College <strong>no es un centro de formación oficial reglada</strong>. No otorga
        títulos académicos oficiales ni certificaciones equivalentes a las del sistema educativo
        español o europeo. La formación que ofrece es de carácter práctico y profesionalizante, no
        académico.
      </p>

      <h2 id="pago">6. Pago y suscripción</h2>
      <h3>6.1. Precio y forma de pago</h3>
      <p>
        El acceso al Programa se realiza mediante una suscripción mensual cuyo precio se indica en
        la página de pago de Skool. Los pagos se gestionan íntegramente a través de Skool y sus
        proveedores de pago (Stripe). Random College no almacena datos bancarios.
      </p>
      <p>Todos los precios incluyen los impuestos aplicables en cada momento, salvo que se indique lo contrario.</p>
      <h3>6.2. Renovación automática</h3>
      <p>
        La suscripción se renueva automáticamente cada mes mientras el usuario no la cancele. La
        cancelación puede realizarse en cualquier momento desde la cuenta del usuario en Skool, sin
        permanencias mínimas ni penalizaciones.
      </p>
      <h3>6.3. Impagos</h3>
      <p>
        En caso de impago de la suscripción, Skool puede suspender automáticamente el acceso al
        Programa hasta que se regularice la situación.
      </p>

      <h2 id="cancelacion">7. Cancelación y devoluciones</h2>
      <h3>7.1. Derecho de desistimiento</h3>
      <p>
        Conforme al Real Decreto Legislativo 1/2007, dispones de un plazo de{' '}
        <strong>14 días naturales desde la contratación</strong> para desistir del servicio sin
        necesidad de justificación. Para ejercer este derecho, escríbenos a{' '}
        <a href="mailto:hola@randomcollege.com">hola@randomcollege.com</a> indicando tu nombre y
        email de registro.
      </p>
      <p>
        <strong>Excepción:</strong> el derecho de desistimiento no se aplica si has comenzado a
        consumir el contenido digital con tu consentimiento expreso y reconocimiento de pérdida del
        derecho. Al inscribirte y acceder al contenido del Programa, reconoces este punto.
      </p>
      <h3>7.2. Cancelación de la suscripción</h3>
      <p>
        Puedes cancelar tu suscripción en cualquier momento. Tras la cancelación, mantendrás acceso
        al Programa hasta el final del período mensual ya pagado. No se realizan reembolsos
        parciales por meses iniciados.
      </p>
      <h3>7.3. Reembolsos por motivos excepcionales</h3>
      <p>
        Estudiamos solicitudes de reembolso fuera del plazo de desistimiento únicamente por motivos
        justificados (errores técnicos graves imputables al servicio, doble cargo, etc.). Las
        solicitudes deben enviarse a <a href="mailto:hola@randomcollege.com">hola@randomcollege.com</a>{' '}
        con la documentación que acredite el motivo.
      </p>

      <h2 id="propiedad">8. Propiedad intelectual</h2>
      <p>
        Todos los contenidos del Sitio y del Programa —incluyendo textos, imágenes, vídeos, audios,
        logos, marcas, código, diseño y estructura— son propiedad de Random College o de terceros
        que han autorizado su uso, y están protegidos por la legislación nacional e internacional
        de propiedad intelectual e industrial.
      </p>
      <p>
        El acceso al Programa otorga al usuario una{' '}
        <strong>licencia personal, intransferible y no exclusiva</strong> para visualizar y consumir
        los contenidos exclusivamente para su uso privado y formativo, durante la vigencia de la
        suscripción.
      </p>
      <p>
        Queda <strong>expresamente prohibido</strong>:
      </p>
      <ul>
        <li>Reproducir, copiar, descargar o redistribuir total o parcialmente los contenidos del Programa.</li>
        <li>Compartir las credenciales de acceso con terceros.</li>
        <li>Grabar las sesiones en directo sin autorización expresa.</li>
        <li>Usar los contenidos con fines comerciales o de explotación.</li>
        <li>Crear obras derivadas a partir del material formativo.</li>
      </ul>
      <p>
        El incumplimiento de estas restricciones puede dar lugar a la cancelación inmediata del
        acceso, sin derecho a reembolso, y al ejercicio de las acciones legales correspondientes.
      </p>

      <h2 id="uso">9. Uso permitido del Sitio y la comunidad</h2>
      <p>
        El usuario se compromete a hacer un uso correcto, lícito y respetuoso del Sitio y de la
        comunidad de Random College en Skool. En particular, se obliga a NO:
      </p>
      <ul>
        <li>Publicar contenidos ilícitos, ofensivos, discriminatorios, violentos, pornográficos o que vulneren derechos de terceros.</li>
        <li>Suplantar la identidad de otras personas.</li>
        <li>Realizar spam o promocionar productos/servicios no autorizados.</li>
        <li>Acosar, amenazar o intimidar a otros miembros de la comunidad.</li>
        <li>Intentar acceder de forma no autorizada a otras cuentas o áreas restringidas.</li>
        <li>Introducir virus, malware o cualquier elemento que pueda dañar los sistemas.</li>
      </ul>
      <p>
        Random College podrá moderar, eliminar contenidos o expulsar a usuarios que incumplan estas
        reglas, sin previo aviso y sin derecho a reembolso.
      </p>

      <h2 id="exclusion">10. Exclusión de responsabilidad</h2>
      <p>
        Random College ofrece el contenido del Programa con el mayor rigor profesional posible,
        pero <strong>no garantiza resultados económicos, profesionales o personales concretos</strong>.
        Los resultados dependen del esfuerzo, contexto y circunstancias individuales de cada
        usuario. Cualquier ejemplo, caso de éxito o testimonio mostrado en el Sitio o en el Programa
        es ilustrativo y no constituye garantía de resultados similares.
      </p>
      <p>Random College no se hace responsable de:</p>
      <ul>
        <li>Decisiones empresariales o financieras tomadas por los usuarios basadas en los contenidos del Programa.</li>
        <li>Interrupciones del servicio causadas por terceros (Skool, proveedores de pago, hosting, etc.).</li>
        <li>Daños derivados del uso indebido de los contenidos.</li>
        <li>Contenidos generados por otros usuarios en la comunidad.</li>
      </ul>

      <h2 id="enlaces">11. Enlaces a sitios externos</h2>
      <p>
        El Sitio puede contener enlaces a sitios web de terceros (Skool, redes sociales,
        herramientas recomendadas, etc.). Random College no controla ni se hace responsable del
        contenido, políticas de privacidad o prácticas de esos sitios externos. La inclusión de un
        enlace no implica aprobación o respaldo del sitio enlazado.
      </p>

      <h2 id="modificaciones">12. Modificaciones</h2>
      <p>
        Random College se reserva el derecho a modificar estos Términos en cualquier momento. Los
        cambios entrarán en vigor desde su publicación en el Sitio. Se notificarán cambios
        significativos a los usuarios suscritos al Programa con al menos{' '}
        <strong>30 días de antelación</strong>, a través del email registrado. El uso continuado
        del Sitio o del Programa tras la entrada en vigor de los cambios implica la aceptación de
        los nuevos términos.
      </p>

      <h2 id="nulidad">13. Nulidad parcial</h2>
      <p>
        Si alguna cláusula de estos Términos fuera declarada nula o inaplicable por una autoridad
        competente, dicha nulidad no afectará al resto de cláusulas, que mantendrán plena
        vigencia. La cláusula nula se sustituirá por otra que, respetando la legalidad, refleje la
        voluntad original de las partes.
      </p>

      <h2 id="legislacion">14. Legislación aplicable y jurisdicción</h2>
      <p>
        Estos Términos se rigen por la legislación española. Para la resolución de cualquier
        controversia, las partes se someten:
      </p>
      <ul>
        <li>
          Si el usuario es <strong>consumidor</strong>: a los juzgados y tribunales del domicilio
          del consumidor, conforme a la normativa de consumo aplicable.
        </li>
        <li>
          Si el usuario actúa como <strong>empresa o profesional</strong>: a los juzgados y
          tribunales de Madrid, con renuncia expresa a cualquier otro fuero que pudiera
          corresponderles.
        </li>
      </ul>
      <p>
        De acuerdo con el Reglamento (UE) 524/2013, los consumidores residentes en la Unión Europea
        pueden acceder a la <strong>plataforma de resolución de litigios en línea</strong> de la
        Comisión Europea:{' '}
        <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer">
          ec.europa.eu/consumers/odr
        </a>
        .
      </p>

      <h2 id="contacto">15. Contacto</h2>
      <p>
        Para cualquier duda, comentario o reclamación relacionada con estos Términos, puedes
        contactarnos en:
      </p>
      <ul>
        <li>
          <strong>Email</strong>: <a href="mailto:hola@randomcollege.com">hola@randomcollege.com</a>
        </li>
        <li>
          <strong>Asunto sugerido</strong>: “Términos — [tu consulta]”
        </li>
        <li>
          <strong>Tiempo medio de respuesta</strong>: menos de 48 horas laborables
        </li>
      </ul>

      <div className="legal-callout" style={{ marginTop: 48 }}>
        <strong>Aviso:</strong> Esta es una plantilla base de Términos y Condiciones que necesita
        ser revisada y completada con los datos legales reales (razón social, NIF, domicilio, datos
        registrales, precios concretos del Programa).{' '}
        <strong>Recomendamos encarecidamente que un abogado especializado revise este documento</strong>{' '}
        antes de su publicación, especialmente las cláusulas sobre derecho de desistimiento,
        propiedad intelectual y exclusión de responsabilidad.
      </div>
    </LegalLayout>
  );
}
